/* Carosello della banda promozionale.
   Si muove con una trasformazione, non con lo scorrimento: il tema rimetteva
   la barra a zero e le slide non cambiavano. Nessuna dipendenza. */
(function () {
  function init(root) {
    if (root.dataset.apReady === '1') return;
    root.dataset.apReady = '1';

    var track = root.querySelector('[data-ap-track]');
    var slides = root.querySelectorAll('.ap-hero__slide');
    var dots = root.querySelectorAll('.ap-hero__dot');
    var tabs = root.querySelectorAll('[data-ap-vai]');
    if (!track || slides.length === 0) return;

    var index = 0;
    var count = slides.length;
    var autoplay = root.dataset.apAutoplay === 'true';
    var delay = parseInt(root.dataset.apDelay, 10) || 6000;
    var timer = null;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function goTo(i) {
      index = (i + count) % count;
      track.style.transform = 'translateX(' + index * -100 + '%)';
      paint();
    }

    function paint() {
      for (var t = 0; t < tabs.length; t++) {
        tabs[t].setAttribute('aria-current', t === index ? 'true' : 'false');
      }
      for (var d = 0; d < dots.length; d++) {
        dots[d].setAttribute('aria-current', d === index ? 'true' : 'false');
      }
      /* i pallini prendono il colore del testo della slide sotto:
         bianchi sulle slide scure, scuri su quelle chiare */
      var tinta = slides[index].getAttribute('data-ap-dot');
      if (tinta) root.style.setProperty('--ap-dot-on', tinta);
      /* l'intestazione trasparente sopra usa testi scuri quando la slide e' chiara */
      root.setAttribute('data-ap-chiaro', slides[index].classList.contains('ap-hero__slide--chiaro') ? 'true' : 'false');
      for (var s = 0; s < slides.length; s++) {
        slides[s].setAttribute('aria-hidden', s === index ? 'false' : 'true');
      }
    }

    function start() {
      if (!autoplay || count < 2 || reduce) return;
      stop();
      timer = window.setInterval(function () { goTo(index + 1); }, delay);
    }
    function stop() {
      if (timer) { window.clearInterval(timer); timer = null; }
    }

    for (var i = 0; i < dots.length; i++) {
      (function (n) {
        dots[n].addEventListener('click', function () { goTo(n); start(); });
      })(i);
    }

    for (var k = 0; k < tabs.length; k++) {
      (function (n) {
        tabs[n].addEventListener('click', function () { goTo(n); start(); });
      })(k);
    }

    /* da telefono: la scheda sotto la foto aggiunge al carrello e apre il foglio del carrello */
    root.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-ap-hero-add]');
      if (!b || b.disabled) return;
      e.preventDefault();
      b.disabled = true; b.classList.add('is-attesa');
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: +b.getAttribute('data-ap-hero-add'), quantity: 1 }] })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: { source: 'ap-hero' } } }));
          b.textContent = 'Aggiunto';
        })
        .catch(function () {})
        .then(function () { b.disabled = false; b.classList.remove('is-attesa'); });
    });

    // scorrimento con il dito
    var x0 = null;
    track.addEventListener('touchstart', function (e) {
      x0 = e.changedTouches[0].clientX;
      stop();
    }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 45) goTo(dx < 0 ? index + 1 : index - 1);
      x0 = null;
      start();
    }, { passive: true });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);

    goTo(0);
    start();

    // editor del tema: porta in vista la slide selezionata
    document.addEventListener('shopify:block:select', function (e) {
      if (!root.contains(e.target)) return;
      var pos = Array.prototype.slice.call(slides).indexOf(e.target);
      if (pos > -1) { stop(); goTo(pos); }
    });
    document.addEventListener('shopify:block:deselect', function (e) {
      if (root.contains(e.target)) start();
    });
  }

  function boot() {
    var all = document.querySelectorAll('[data-ap-hero]');
    for (var i = 0; i < all.length; i++) init(all[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
